<template>
	<v-dialog v-model="dialog" persistent max-width="800" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between">
				<div class="font-size-13 font-size-xs-11 cl-dark-green">Detail Produk</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-2">
				<v-row v-if="Object.keys(detailProduct).length > 0">
					<v-col cols="12" sm="4">
						<template v-if="detailProduct.hasOwnProperty('product_image_formatted') && detailProduct.product_image_formatted.length > 0">
							<carousel ref="carousel" id="owl-menu" class="col-12 pa-0" :responsive="{0:{items:1},600:{items:1},1000:{items:1}}" :margin="0" :autoplay="false" :nav="false" :loop="false" :dots="true">
								<div v-for="(image, i) in detailProduct.product_image_formatted" :key="i">
									<v-img height="280" class="mx-auto rounded-xl" :src="image"></v-img>
								</div>
							</carousel>
						</template>
						<template v-else>
							<v-img width="100%" height="280" class="mx-auto rounded-xl" src="assets/image/user-pict.jpg"></v-img>
						</template>
					</v-col>
					<v-col cols="12" sm="8">
						<div class="font-size-11 cl-dark-green">{{ detailProduct.product_name }}</div>
						<div class="font-size-12 cl-primary">{{ detailProduct.product_member_price | toRupiah }}</div>
						<div class="pt-1 font-size-10 cl-grey">{{ detailProduct.product_weight | toKg }}</div>
						<div class="pt-5 cl-dark-green font-size-11 font-weight-bold">Deskripsi</div>
						<div class="pt-1 font-size-11 cl-dark-green" v-html="detailProduct.product_description ? detailProduct.product_description : '-'"></div>
					</v-col>
				</v-row>
				<v-row v-else>
					<v-col cols="12">
						<v-card loading class="elevation-0">
							<div class="d-flex flex-column align-center pa-5 my-4">
								<v-img eager class="mx-auto" width="50" height="50" src="assets/icon/loading.svg"></v-img>
								<div class="pt-3 text-center cl-secondary">Sedang memuat informasi...</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import carousel from 'vue-owl-carousel'

export default {
	components: {
		carousel
	},
	data () {
		return {
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState('transactionProduct', ['detailProduct']),
	},
	methods: {
		...mapMutations('transactionProduct', ['clearDetailProduct']),

		modalHide() {
			this.dialog = false
			this.clearDetailProduct()
		},
		modalShow() {
			this.dialog = true
		},
	}
};
</script>